import React, { useState, useEffect } from 'react';
import BreakCrumbs from '../../components/BreakCrumbs';
import {
  Box,
  Paper,
  Grid,
  Typography,
  Divider,
  Button,
  Drawer,
} from '@material-ui/core';
import TableLoading from '../../components/TableLoading';
import { alertError } from '../../Util/Util';
import TableEmpty from '../../components/TableEmpty';
import { LIST_PAGE_COUNT } from '../../data/common';
import { trim, map } from 'lodash';
import bonusProductAPI from '../../middleware/bonusProductAPI';
import QrCodeWithLogo from 'qrcode-with-logos';
import BonusProductQRCodeGroupTable from '../../components/BonusProduct/BonusProductQRCodeGroupTable';
import AddRoundedIcon from '@material-ui/icons/AddRounded';
import BonusProductQRCodeGroupAddModal from './BonusProductQRCodeGroupAddModal';
import { DatePicker } from '@material-ui/pickers';
import SearchIcon from '@material-ui/icons/Search';
import moment from 'moment';
import GetAppRoundedIcon from '@material-ui/icons/GetAppRounded';
import qrcodeLogo from '../../images/qrcode_logo.png';
import { saveAs } from 'file-saver';
import Swal from 'sweetalert2';
import BonusProductQRCodeGroupDetail from './BonusProductQRCodeGroupDetail';

const BonusProductQRCodeGroupList = (props) => {
  const { match } = props;
  const [qrcodeGroups, setQRCodeGroups] = useState();
  const [total, setTotal] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [isOpenAddQRCodeGroupModal, setIsOpenAddQRCodeGroupModal] = useState(
    false,
  );
  const [search, setSearch] = useState({
    startAt: '',
    endAt: '',
  });
  const [isOpenDetail, setIsOpenDetail] = useState(false);
  const [showDetailGroupId, setShowDetailGroupId] = useState();

  useEffect(() => {
    searchGroups();
  }, [page]);

  const handleChangeSearch = (searchName, value) => {
    setSearch({
      ...search,
      [searchName]: value,
    });
  };

  const handleSearch = () => {
    if (page !== 1) {
      setPage(1);
    } else {
      searchGroups();
    }
  };

  const searchGroups = () => {
    setIsLoading(true);

    bonusProductAPI
      .getQRCodeGroups(
        page,
        LIST_PAGE_COUNT,
        trim(search.startAt) !== ''
          ? moment(search.startAt).format('YYYY-MM-DD')
          : undefined,
        trim(search.endAt) !== ''
          ? moment(search.endAt).format('YYYY-MM-DD')
          : undefined,
      )
      .then(
        (res) => {
          setQRCodeGroups(res.bonusProductQRCodeGroupList);
          setTotal(res.totalCount);
        },
        (error) => {
          alertError(error);
        },
      )
      .then(() => {
        setIsLoading(false);
      });
  };

  const handleSetPage = (page) => {
    setPage(page);
  };

  const downloadQRCode = async (QRCodeGroup) => {
    setIsLoading(true);

    const fileName = 'GroupQRCode-' + trim(QRCodeGroup.groupId) + '.png';
    const qrcodeCanvas = document.createElement('canvas');
    const qrcode = new QrCodeWithLogo({
      canvas: qrcodeCanvas,
      content: QRCodeGroup.qRCodeValue,
      width: 100,
      nodeQrCodeOptions: {
        margin: 1,
      },
    });

    qrcode.downloadImage(fileName);

    setIsLoading(false);
  };

  const handleOpenAddQRCodeGroupModal = () => {
    setIsOpenAddQRCodeGroupModal(true);
  };

  const handleCloseAddQRCodeGroupModal = () => {
    setIsOpenAddQRCodeGroupModal(false);
  };

  const downloadAllQRCode = () => {
    setIsLoading(true);

    return bonusProductAPI
      .getQRCodeGroups(
        1,
        9999999,
        trim(search.startAt) !== ''
          ? moment(search.startAt).format('YYYY-MM-DD')
          : undefined,
        trim(search.endAt) !== ''
          ? moment(search.endAt).format('YYYY-MM-DD')
          : undefined,
      )
      .then((response) => {
        if (response.totalCount <= 0) {
          Swal.fire({
            title: '搜尋結果無資料',
            icon: 'warning',
          });
        } else {
          const zip = require('jszip')();

          return getAllUrlQrcodeImg(response.bonusProductQRCodeGroupList).then(
            (allQrCodeImg) => {
              for (let urlQrCode of allQrCodeImg) {
                zip.file(urlQrCode.name, urlQrCode.img.split('base64,')[1], {
                  base64: true,
                });
              }

              return zip.generateAsync({ type: 'blob' }).then((content) => {
                saveAs(content, 'GROUP-QRCODE.zip');
                setIsLoading(false);
              });
            },
          );
        }
      })
      .then(() => {
        setIsLoading(false);
      });
  };

  const getAllUrlQrcodeImg = async (nodes) => {
    let qrcodes = [];

    for (let node of nodes) {
      const fileName =
        `GroupQRCode-${node.groupId}-${node.qRCodeValue}` + '.png';
      const qrcodeCanvas = document.createElement('canvas');
      const qrcode = new QrCodeWithLogo({
        canvas: qrcodeCanvas,
        content: node.qRCodeValue,
        width: 200,
        logo: qrcodeLogo,
      });

      await qrcode.toCanvas().then(() => {
        qrcodes.push({
          name: fileName,
          img: qrcodeCanvas.toDataURL('image/png'),
        });
      });
    }

    return qrcodes;
  };

  const openDetail = (groupId) => {
    setIsOpenDetail(true);
    setShowDetailGroupId(groupId);
  };

  const handleCloseDetail = () => {
    setIsOpenDetail(false);
    setShowDetailGroupId(undefined);
  };

  return (
    <div className="popular pagefadeIn">
      <BreakCrumbs path={match.url}></BreakCrumbs>

      <Box component={Paper} square elevation={2} p={1} mt={3} mb={3}>
        <Grid
          container
          direction="row"
          justify="space-around"
          alignItems="center">
          <Grid item xs>
            <Typography variant="h4" color="textPrimary" gutterBottom>
              紙本序號打包列表
            </Typography>
          </Grid>

          <Grid item xs>
            <Box textAlign="right">
              <Button
                variant="contained"
                color="primary"
                disabled={isLoading}
                startIcon={<AddRoundedIcon />}
                onClick={handleOpenAddQRCodeGroupModal}>
                新增打包序號
              </Button>
            </Box>
          </Grid>
        </Grid>

        <Divider light />

        <Box textAlign="right" mt={2} mb={2}>
          <DatePicker
            autoOk
            label="建立開始時間"
            clearable
            disableFuture
            inputVariant="outlined"
            size="small"
            value={search.startAt || null}
            onChange={(e) => {
              handleChangeSearch('startAt', e);
            }}
            format="yyyy-MM-dd"
            style={{
              marginRight: '12px',
            }}
          />

          <DatePicker
            autoOk
            label="結束時間"
            clearable
            disableFuture
            size="small"
            inputVariant="outlined"
            value={search.endAt || null}
            onChange={(e) => {
              handleChangeSearch('endAt', e);
            }}
            format="yyyy-MM-dd"
            style={{
              marginRight: '12px',
            }}
          />

          <Button
            variant="contained"
            color="secondary"
            startIcon={<GetAppRoundedIcon />}
            disabled={isLoading}
            onClick={downloadAllQRCode}
            style={{
              marginRight: '12px',
            }}>
            下載搜尋結果QRCODE
          </Button>

          <Button
            variant="contained"
            color="primary"
            startIcon={<SearchIcon />}
            disabled={isLoading}
            onClick={handleSearch}>
            搜尋
          </Button>
        </Box>

        {isLoading && <TableLoading />}

        {!isLoading && !qrcodeGroups && <TableEmpty message="無打包紙本序號" />}

        {!isLoading && qrcodeGroups && (
          <BonusProductQRCodeGroupTable
            QRCodeGroups={qrcodeGroups}
            total={total}
            page={page}
            setPage={handleSetPage}
            isLoading={isLoading}
            downloadQRCode={downloadQRCode}
            openDetail={openDetail}
          />
        )}
      </Box>

      <BonusProductQRCodeGroupAddModal
        isOpen={isOpenAddQRCodeGroupModal}
        close={handleCloseAddQRCodeGroupModal}
        refreshList={searchGroups}
      />

      <Drawer anchor="right" open={isOpenDetail} onClose={handleCloseDetail}>
        <BonusProductQRCodeGroupDetail
          groupId={showDetailGroupId}
          closeDrawer={handleCloseDetail}
          refreshList={searchGroups}
        />
      </Drawer>
    </div>
  );
};

export default BonusProductQRCodeGroupList;
